import { Box, Stack, useElementBreakpoints } from "@compass/core";
import { CustomFilters } from "components";
import { CustomEntityOption } from "components/common/CustomFilters/CustomFilter";
import {
  CustomFilterEntity,
  LkStudentEnrollmentDisplayFieldId,
  StudentEnrollmentFilterResource,
  StudentFilter as StudentFilterModel,
  StudentFilterResource,
  StudentListFilter,
  StudentServiceFilterResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { StudentEnrollmentFilterAccordion } from "../student-enrollments/StudentEnrollmentFilterAccordion";
import { StudentServiceFilterAccordion } from "../student-services/StudentServiceFilterAccordion";
import { StudentDemographicsFilterAccordion } from "./StudentDemographicsFilterAccordion";
import { FilterAccordion } from "components/common/CustomFilters/FilterAccordion";

export const StudentFilter = (props: {
  filter: StudentListFilter;
  setFilter: (filter: StudentListFilter) => void;
}) => {
  const { breakpointsRef, largeFieldBreakpoints, fullFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<StudentFilterResource>({} as StudentFilterResource);
  const [enrollmentResource, setEnrollmentResource] = useState<StudentEnrollmentFilterResource>({});
  const [serviceResource, setServiceResource] = useState<StudentServiceFilterResource>({});
  const properties = resource.properties || [];
  const displayFields = resource.enrollmentDisplayFields || [];

  const gradeLevelDisplayField = displayFields.find((x) => x.id === LkStudentEnrollmentDisplayFieldId.GradeLevel);
  const schoolDisplayField = displayFields.find((x) => x.id === LkStudentEnrollmentDisplayFieldId.School);

  const entityOptions: CustomEntityOption[] = [
    { EntityType: CustomFilterEntity.Student, EntityName: "Demographics" },
    { EntityType: CustomFilterEntity.StudentEnrollment, EntityName: "Enrollments" },
    { EntityType: CustomFilterEntity.StudentAbsence, EntityName: "Absences" },
    { EntityType: CustomFilterEntity.StudentApplication, EntityName: "Application" },
    { EntityType: CustomFilterEntity.StudentDiploma, EntityName: "Diploma" },
    { EntityType: CustomFilterEntity.StudentFafsa, EntityName: "FAFSA" },
    { EntityType: CustomFilterEntity.StudentGpa, EntityName: "GPA" },
    { EntityType: CustomFilterEntity.StudentGrades, EntityName: "Grades" },
    { EntityType: CustomFilterEntity.StudentParent, EntityName: "Parent" },
    { EntityType: CustomFilterEntity.StudentPostHighSchool, EntityName: "Post HS Plans" },
    { EntityType: CustomFilterEntity.PostSecondary, EntityName: "Post Secondary" },
    { EntityType: CustomFilterEntity.StudentService, EntityName: "Services" },
    { EntityType: CustomFilterEntity.StudentScholarship, EntityName: "Scholarship" },
    { EntityType: CustomFilterEntity.StudentTest, EntityName: "Test Scores" },
  ];

  useEffect(() => {
    ApiService.students.getFilterResource().then((response) => {
      setResource(response);
    });

    ApiService.studentEnrollments.getFilterResource().then((response) => {
      setEnrollmentResource(response);
    });

  }, []);

  return (
    <Stack ref={breakpointsRef} spacing="md" padding={2}>
      <CustomFilters
        allowedEntityTypes={entityOptions}
        filters={props.filter.customFilters}
        setFilters={(filters) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.customFilters = filters;
            })
          )
        }
        properties={resource.customFilterProperties}
      />
      <Box>
        <FilterAccordion title="Demographics" defaultExpanded>
          <StudentDemographicsFilterAccordion
            filter={props.filter.studentFilter!}
            resource={resource}
            setFilter={(subFilter) =>
              props.setFilter(
                produce(props.filter, (draft) => {
                  draft.studentFilter = subFilter;
                })
              )
            }
          /></FilterAccordion>
      </Box>
      {/* 
      <Box>
        <FilterAccordion title="Enrollment">
          <StudentEnrollmentFilterAccordion
            filter={props.filter}
            setFilter={props.setFilter}
            resource={enrollmentResource}
          /></FilterAccordion>
      </Box> */}
    </Stack>
  );
};
